export const servicesList = [
  { id: "1", description: "Balayage", price: "", duration: "3" },
  { id: "11", description: "Blowdry/Set", price: "", duration: "0.25" },
  {
    id: "15",
    description: "Child Cut (0-2 Yrs) Mon-Wed only",
    price: "",
    duration: "0.25",
  },
  { id: "16", description: "Child Cut (3-5 Yrs)", price: "", duration: "0.25" },
  {
    id: "17",
    description: "Child Cut (6-13 Yrs)",
    price: "",
    duration: "0.25",
  },
  {
    id: "18",
    description: "Child Cut (14-17 Yrs)",
    price: "",
    duration: "0.25",
  },
  { id: "3", description: "Colour", price: "", duration: "2" },
  { id: "8", description: "Eyebrow Wax", price: "", duration: "0.25" },
  { id: "9", description: "Eyebrow Tint", price: "", duration: "0.25" },
  { id: "10", description: "Eyelash Tint", price: "", duration: "0.25" },
  { id: "13", description: "Female Cut", price: "", duration: "0.25" },
  { id: "4", description: "Foils", price: "", duration: "2" },
  {
    id: "12",
    description: "Mens 10 Minute Colour",
    price: "",
    duration: "0.25",
  },
  { id: "14", description: "Mens Cut", price: "", duration: "0.25" },
  { id: "5", description: "Perm", price: "", duration: "2" },
  { id: "2", description: "Permanent Straightening", price: "", duration: "3" },
  {
    id: "7",
    description: "Hair Extensions Consultation*",
    price: "",
    duration: "0.25",
  },
  { id: "6", description: "Treatment", price: "", duration: "2" },
];

export const resourcesList = [
  "Stylist 1",
  "Stylist 2",
  "Stylist 3",
  "Stylist 4",
  "Stylist 5",
  "Stylist 6",
  "Stylist 7",
  "Overflow",
];

export const serviceColors = {
  1: "red-darken-1",
  11: "pink-darken-1",
  15: "purple-darken-1",
  16: "indigo-darken-1",
  17: "blue-darken-1",
  18: "cyan-darken-1",
  3: "light-blue-darken-1",
  8: "teal-darken-1",
  9: "green-darken-1",
  10: "lime-darken-1",
  13: "yellow-darken-1",
  4: "amber-darken-1",
  12: "orange-darken-1",
  14: "deep-orange-darken-1",
  5: "brown-darken-1",
  2: "blue-grey-darken-1",
  7: "grey-darken-1",
  6: "cyan-accent-2",
};
